import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        'NO_TREE': 'No tree',
        'ONE_LEVEL': 'One level',
        'ALL_TREE': 'All tree',
      },
    }
  }
}





